/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'behance': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#0071b9" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M19.723 9.205h6.236v1.551h-6.236V9.205zM28.441 17.924c0 .28-.011.549-.034.807h-8.021c-.074 1.768 1.216 2.821 2.684 2.821 1.04 0 1.954-.552 2.481-1.487h2.625c-.72 2.629-2.837 3.723-5.336 3.723-3.273 0-5.6-2.625-5.6-5.864s2.507-5.864 5.6-5.864 5.6 2.625 5.6 5.864zm-8.054-1.151h4.933c-.196-1.457-1.226-2.386-2.466-2.386s-2.27.929-2.466 2.386zM16.279 18.172c.202 2.249-.202 3.645-2.498 4.778-.859.424-1.937.557-2.947.557H3.559V8.213h8.005c.993 0 4.059.589 4.077 3.537.012 2.038-1.142 2.969-2.105 3.415 0 0 2.543.758 2.745 3.007zm-3.277.647c0-2.146-2.424-2.09-2.424-2.09H6.924v4.181h3.654s2.424.056 2.424-2.09zm-.601-6.216c0-1.799-2.032-1.753-2.032-1.753H6.925v3.506h3.444s2.032.046 2.032-1.753z"/>'
  }
})
